import React, { Component } from 'react';
import TopBar from '../components/TopBar.js';

//import '../resources/bootstrap/dist/css/bootstrap.min.css';
import '../resources/bootstrap/themes/bootstrap.min.css';
import '../resources/css/AdminPage.css';

class AdminPage extends Component {

  render() {
    return (
      <div>
        <TopBar user={this.props.user}/>
        <div className="container pageContainer">
          {this.props.children}
        </div>
        <footer className="footer hidden-lg hidden-md hidden-sm hidden-xs">
          <div className="container">
            <p className="text-muted">Powered by Playsmatch.</p>
          </div>
        </footer>
      </div>
    );
  }
}

export default AdminPage;


// WEBPACK FOOTER //
// ./src/views/AdminPage.js